<!--ネイティブの仕様上ダイアログだとデザインが崩れるのでindex用にフラットなデザインのダイアログもどきコンポーネント-->
<template>
  <div class="dialog-container">
    <transition name="backdrop" appear>
      <div
        v-show="visible"
        class="dialog-backdrop"
        style="background: white; padding: 30px 0px 0px"
      >
        <PulseLoader
          v-if="imageType === 'loader'"
          style="text-align: center; margin-top: 0px"
          color="#fdc908"
        />

        <FacePhraseForIndexPage :phrase="title" />

        <div class="button-container">
          <slot name="button-area"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ItemDialogForIndexPage",
  props: {
    imageType: {
      type: String,
      required: false,
      default: "loader",
    },
    initialOpen: {
      type: Boolean,
      required: false,
      default: true,
    },
    title: {
      type: String,
      required: false,
      default: "読み込み中",
    },
  },
  data() {
    return {
      visible: this.initialOpen,
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// 遷移中のスタイル
.backdrop-enter-active,
.backdrop-leave-active,
.dialog-enter-active,
.dialog-leave-active {
  transition: all 0.3s;
}

// 表示前、非表示完了のスタイル
.backdrop-enter,
.backdrop-leave-to,
.dialog-enter,
.dialog-leave-to {
  opacity: 0;
}

// 表示完了、非表示前のスタイル
.backdrop-enter-to,
.backdrop-leave,
.dialog-enter-to,
.dialog-leave {
  opacity: 1;
}

.custom-image {
  width: 80% !important;
  height: 80% !important;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

.demand_dialog {
  top: 22% !important;
}

.non-message {
  text-align: center;
  color: #777777;
  font-weight: bold;
  padding: 10px;
}
</style>
